<!--
 * @Author: wangwang 2723008256@qq.com
 * @Date: 2023-08-11 09:06:57
 * @LastEditors: 番茄炒蛋蛋 wzh15802755802@163.com
 * @LastEditTime: 2025-03-12 11:24:13
 * @FilePath: \jzjypc4.2\src\components\yuyueBox\yuyuebox.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="yuyueevm">
      <el-dialog  :visible.sync="dialogVisible" :before-close="handleClose" width="480px" top="30vh">
        <div class="yyevmContent">
          <div class="top">
            <h3>购买资源</h3>
          </div>
          <div class="zyBox">
            <div class="kejianfile">
              <img
                src="../../assets/img/ziyuanbaonew.png"
                alt="file_url"
                v-if="suffix == 'zyb'"
                style="margin-left: 10px;margin-top: 10px;
                width: 63px;
                height: auto;"
              />
              <img
                src="../../assets/img/resFile (1).png"
                alt="file_url"
                v-if="
                  suffix == 'ppt' ||
                  suffix == 'pptx' ||
                  suffix == 'ppsx' ||
                  suffix == 'pps'
                "
              />
              <img
                src="../../assets/img/resFile (2).png"
                alt="file_url"
                v-if="suffix == 'mp4' || suffix == 'rm'"
              />
              <img
                src="../../assets/img/resFile (3).png"
                alt="file_url"
                v-if="suffix == 'xls' || suffix == 'xlsx'"
              />
              <img
                src="../../assets/img/resFile (4).png"
                alt="file_url"
                v-if="suffix == 'zip' || suffix == 'rar'"
              />
              <img
                src="../../assets/img/resFile (5).png"
                alt="file_url"
                v-if="suffix == 'm4a' || suffix == 'mp3'"
              />
              <img
                src="../../assets/img/resFile (6).png"
                alt="file_url"
                v-if="suffix == 'doc' || suffix == 'docx'"
              />
              <img
                src="../../assets/img/resFile (7).png"
                alt="file_url"
                v-if="suffix == 'pdf'"
              />
              <img
                src="../../assets/img/resFile (8).png"
                alt="file_url"
                v-if="suffix == 'png' || suffix == 'jpg'"
              />
            </div>
            <div class="title">
              {{title}}
            </div>
          </div>
          <div class="signSuccessContent">
            <div class="pic">
              <img :src="zykf_file_url" alt="" />
              <p>扫描二维码支付</p>
            </div>
            <div class="msg">
              <p>使用微信扫码支付</p>
              <h3>￥{{price}}</h3>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
</template>

<script>
export default {
  props:['zykf_file_url','suffix','title','price'],
  inject: ["reload"],
    data(){
        return{
          dialogVisible:true,
        }
    },
    methods:{
      handleClose(){
        this.$emit('closefwbtj')
      }
    },
}
</script>

<style lang="less" scoped>
    .yuyueevm {
    /deep/.el-dialog__header {
      padding: 0;
    }
    /deep/.el-dialog {
      margin-top: 13vh !important;
      border-radius: 20px;
    }
    /deep/.el-dialog__body {
      padding: 0;
      height: 450px;
    }
    /deep/.el-dialog__headerbtn .el-dialog__close{
        color: #C0C1C5 !important;
        right: 10px !important;
    }
    /deep/.el-dialog__headerbtn{
      right: 10px !important;
    }
    .yyevmContent {
      width: 480px;
      height: 500px;
      border-radius: 20px;
      .top {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 480px;
        height: 80px;
        border-radius: 20px 20px 0px 0px;
        img{
            width: 40px;
        }
        h3 {
            text-align: center;
            font-size: 18px;
            line-height: 30px;
            color: #333333;
        }
      }
      .zyBox{
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin: 0 auto;
        width: 400px;
        height: 120px;
        background: #F5F5F5;
        border-radius: 10px;
        .kejianfile{
          width: 74px;
          height: 84px;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .title{
          width: 270px;
        }
      }
      .signSuccessContent {
        display: flex;
        justify-content: center;
        margin-top: 34px;
        .pic {
          margin-bottom: 20px;
          width: 160px;
          height: 160px;
          border: 1px solid #dedede;
          img {
            width: 160px;
            height: 160px;
          }
          p{
            margin-top: 10px;
            text-align: center;
            font-size: 12px;
            color: #999999;
          }
        }
        .msg{
          margin-left: 30px;
          width: 180px;
          p{
            margin-top: 14px;
            margin-bottom: 26px;
            color: #333333;
            font-size: 16px;
            font-weight: 600;
          }
          h3{
            font-size: 32px;
            color: #E63F3F;
            line-height: 28px;
          }
        }
      }
    }
  }
</style>